const ShopVerifyList = () => import('@/modules/fwscverify/shopverify/ShopVerifyList.vue')
const GoodsVerifyList = () => import('@/modules/fwscverify/goodsverify/GoodsVerifyList.vue')
const ShopScore = () => import('@/modules/fwscverify/shopscore/MartCodePoints.vue')
const MartCreditList = () => import('@/modules/fwscverify/shopcredit/MartCreditList.vue')
const YearFeeList = () => import('@/modules/fwscverify/yearfee/YearFeeList.vue')
const YearfeePayList = () => import('@/modules/fwscverify/yearfeepay/YearfeePayList.vue')
const FwscStatistics = () => import('@/modules/fwscstatistic/FwscStatistics.vue')
const AdApplyList = () => import('@/modules/fwscverify/adapply/AdApplyList.vue')
const AdCheckList = () => import('@/modules/fwscverify/adcheck/AdCheckList.vue')
export default [{

  path: '/fwscverify/shopverify',
  name: 'shopVerify',
  component: ShopVerifyList,
  meta: {
    title: '店铺审核',
    isBlack: true
  },
},
{

  path: '/fwscverify/goodsverify',
  name: 'goodsVerify',
  component: GoodsVerifyList,
  meta: {
    title: '商品审核',
    isBlack: true
  },
},
{

  path: '/martcredit',
  name: 'martcredit',
  component: MartCreditList,
  meta: {
    title: '商家信用体系',
    isBlack: true
  },
},
{

  path: '/score',
  name: 'shopscore',
  component: ShopScore,
  meta: {
    title: '评分规则',
    isBlack: true
  },
},
{

  path: '/yearfee',
  name: 'yearfee',
  component: YearFeeList,
  meta: {
    title: '年费标准管理',
    isBlack: true
  },
},
{

  path: '/yearfeepay',
  name: 'yearfeepay',
  component: YearfeePayList,
  meta: {
    title: '年费缴纳管理',
    isBlack: true
  },
},
{

  path: '/fwscstatistics',
  name: 'fwscstatistics',
  component: FwscStatistics,
  meta: {
    title: '商城统计',
    isBlack: true
  },
},
{

  path: '/adapply',
  name: 'adapply',
  component: AdApplyList,
  meta: {
    title: '已申请广告位',
    isBlack: true
  },
},
{

  path: '/adcheck',
  name: 'adcheck',
  component: AdCheckList,
  meta: {
    title: '广告位申请审核',
    isBlack: true
  },
},
]
